import { useMemo } from 'react';
import { type MenuItem } from '@direct-frontend/components';
import { useToggle } from '@direct-frontend/stdlib';
import { type OpenApiSchemaAddonListItem } from '#shared/api/schema';
import { useConfirm } from '#shared/lib/hooks';
import { showError, showSuccess } from '#shared/lib/toast';
import { deleteAddon } from '../api';

export const useActionRemove = (addonId: OpenApiSchemaAddonListItem['id'], onRemove?: VoidFunction) => {
    const { renderConfirmModal, confirm } = useConfirm();
    const { value: isRemoving, toggleOn: startRemoving, toggleOff: stopRemoving } = useToggle();

    const menuItem = useMemo<MenuItem>(() => {
        return {
            content: 'Удалить',
            value: 'delete',
            onAction: async () => {
                const isConfirmed = await confirm({
                    title: 'Удалить услугу?',
                    applyText: 'Да, удалить',
                });

                if (!isConfirmed) {
                    return;
                }

                startRemoving();

                try {
                    await deleteAddon({ params: { id: addonId } });
                    showSuccess('Услуга удалена');
                } catch (error) {
                    showError({ label: 'Не удалось удалить услугу' }, error);
                }

                stopRemoving();

                onRemove?.();
            },
            disabled: isRemoving,
        };
    }, [addonId, confirm, startRemoving, stopRemoving, isRemoving, onRemove]);

    return { menuItem, renderConfirmModal };
};
